(() => {
  const MESSAGE_SELECTOR = '[id$="__announcement_bar_EGpazV"] .announcement-bar__message > span';

  const enhanceSeparators = (message) => {
    if (message.dataset.customSeparatorsReady === 'true') return;

    const text = message.textContent;
    const parts = text.split('·');
    if (parts.length < 2) return;

    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      fragment.append(document.createTextNode(part.trim()));

      if (index < parts.length - 1) {
        const separator = document.createElement('span');
        separator.className = 'custom-announcement-separator';
        separator.textContent = '·';
        fragment.append(separator);
      }
    });

    message.replaceChildren(fragment);
    message.dataset.customSeparatorsReady = 'true';
  };

  const initialize = () => {
    document.querySelectorAll(MESSAGE_SELECTOR).forEach(enhanceSeparators);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
